import { Modal, Form, Select, FormInstance } from "antd";
import { usePositionTaskMutations } from "employee_tasks/hooks/useTasks";
import { TaskPrioritySchema } from "@/employee_tasks/types/task";
import type { Task, CreateTaskInput } from "@/employee_tasks/types/task";
import { priorityNames } from "../table/columns";
import { TemplateSelect } from "../template/TemplateSelect";
const useTranslation = () => {
  return { t: (text: string) => text };
};

export const TaskModal = ({
  form,
  positionId,
  editingTask,
  isModalVisible,
  handleCloseModal,
  setIsTemplateModalVisible,
}: {
  form: FormInstance<any>;
  positionId: number;
  editingTask: Task | null;
  isModalVisible: boolean;
  handleCloseModal: () => void;
  setIsTemplateModalVisible: (search?: string) => void;
}) => {
  const { t } = useTranslation();
  const { create, update } = usePositionTaskMutations(positionId);

  // Handle form submit
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const data: CreateTaskInput = {
        ...values,
      };

      if (editingTask) {
        await update.mutateAsync({ id: editingTask.id, data });
      } else {
        await create.mutateAsync(data);
      }

      handleCloseModal();
    } catch (error) {
      console.error("Form validation failed:", error);
    }
  };
  return (
    <Modal
      title={editingTask ? t("Editar Tarefa") : t("Criar Tarefa")}
      open={isModalVisible}
      onCancel={handleCloseModal}
      onOk={handleSubmit}
      okText={editingTask ? t("Salvar") : t("Criar")}
      cancelText={t("Cancelar")}
      confirmLoading={create.isLoading || update.isLoading}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="template_task_id"
          label={t("Template de Tarefa")}
          rules={[
            { required: true, message: t("Selecione um template de tarefa") },
          ]}
        >
          <TemplateSelect
            createTemplateProps={{
              allowCreate: true,
              setIsTemplateModalVisible,
            }}
            usedTemplatesFilter={[
              {
                id: positionId,
                model: "position",
              },
            ]}
          />
        </Form.Item>

        <Form.Item
          name="priority"
          label={t("Prioridade")}
          rules={[{ required: true, message: t("Selecione a prioridade") }]}
        >
          <Select
            placeholder={t("Selecione a prioridade")}
            options={TaskPrioritySchema.options.map((priority) => ({
              key: priority,
              value: priority,
              label: priorityNames[priority],
            }))}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
